<template>
  <portal to="modal">
    <transition name="from-right">
      <div
        class="order-modal-wrapper"
        v-if="this.$store.state.main.orderActive"
      >
        <div class="auth-wrapper" v-if="authActive">
          <div class="upper-wrapper">
            <div class="close-wrapper">
              <svg
                id="j-logo-modal"
                xmlns="http://www.w3.org/2000/svg"
                width="59.999"
                height="60"
                viewBox="0 0 59.999 60"
              >
                <g
                  id="Group_99"
                  data-name="Group 99"
                  transform="translate(-692.335 -235.632)"
                >
                  <path
                    id="Path_211"
                    data-name="Path 211"
                    d="M748.311,250.636a29.994,29.994,0,1,1-40.973-10.981,29.993,29.993,0,0,1,40.973,10.981"
                    transform="translate(0 0)"
                    fill="#bacb32"
                    fill-rule="evenodd"
                  />
                  <path
                    id="Path_212"
                    data-name="Path 212"
                    d="M725.648,278.672c-2.532,1.462-5.039.905-6.223-1.146-1.027-1.779-.725-3.777.369-4.409a.95.95,0,0,1,1.216.21,2.87,2.87,0,0,0-.122,3.263,2.258,2.258,0,0,0,3.3.826c2.53-1.461,1.953-4.044.184-7.581-4.062-8.141-9.117-17.53-10.815-20.47a15.3,15.3,0,0,1-2.967,7.181c2.469-.147,4.782.7,5.652,2.209,1.381,2.392.248,4.692-1.806,5.877-1.64.947-3.671.748-4.618-.892a2.106,2.106,0,0,1,.713-2.873c.718.77,1.691,1.668,3.2.8a1.417,1.417,0,0,0,.519-1.943c-.829-1.435-2.859-1.634-4.561-1.741a1.208,1.208,0,0,1-.955-.544c-.2-.342-.149-.736.242-1.325,4-5.86,2.291-8.346,4.754-9.767,1.982-1.144,3.652,1.9,4.785,3.711,1.571,2.558,4.7,8.137,8.762,16.279,2.254,4.535,3.908,9.139-1.629,12.336"
                    transform="translate(3.137 2.015)"
                    fill="#101820"
                  />
                </g>
              </svg>

              <div class="close-btn" @click="openorderModal()">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26.469"
                  height="27.766"
                  viewBox="0 0 26.469 27.766"
                >
                  <g
                    id="Group_240"
                    data-name="Group 240"
                    transform="translate(-1721.922 -107.326)"
                  >
                    <path
                      id="Path_1643"
                      data-name="Path 1643"
                      d="M1.327,4.6c5.967.11,11.824-1.074,17.777-1.2,3.641-.077,7.6.437,11.16-.633.884-.266,1.97-.777,1.935-1.837l0-.129C32.16-.223,30.251-.187,28.922.468c-3.236.742-6.913.076-10.173.249C13.5,1,8.309,1.961,3.043,1.863,1.23,1.831-1.742,4.544,1.327,4.6Z"
                      transform="translate(1725.181 107.326) rotate(45)"
                      fill="#101820"
                    />
                    <path
                      id="Path_1644"
                      data-name="Path 1644"
                      d="M29.1.291c-3.635,1.787-8.026,1.644-11.979,1.44A123.652,123.652,0,0,1,3.008.37C.8,0-1.6,3.126,1.433,3.635A110.5,110.5,0,0,0,18.464,5.1c4.3.045,8.71-.245,12.631-2.173C33.875,1.564,31.384-.833,29.1.291Z"
                      transform="translate(1721.922 131.48) rotate(-45)"
                      fill="#101820"
                    />
                  </g>
                </svg>

                <span class="f-21 regular">
                  {{ $fn.tr("დახურვა") }}
                </span>
              </div>
            </div>
            <div class="order-modal-inner">
              <h2 class="f-34">{{ $fn.tr("შეკვეთა") }}</h2>

              <div class="err-block">
                <transition name="fade">
                  <errorBlock
                    v-if="userError"
                    :text="'ელ. ფოსტა ან პაროლი არასწორია'"
                  />
                </transition>
              </div>
              <el-form
                :model="orderform"
                :rules="orderrules"
                ref="orderform"
                class="contact-form"
              >
                <el-form-item prop="inputname">
                  <el-input
                    :placeholder="$fn.tr('სახელი')"
                    v-model="orderform.inputname"
                    type="text"
                    class="orderinname"
                    :class="{ err: userError }"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="phone">
                  <el-input
                    :placeholder="$fn.tr('ტელეფონი')"
                    v-model.number="orderform.phone"
                    type="email"
                    class="orderinmail"
                    :class="{ err: userError }"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="inputLocation">
                  <el-input
                    :placeholder="$fn.tr('ლოკაცია')"
                    v-model="orderform.inputLocation"
                    type="text"
                    class="orderinname"
                    :class="{ err: userError }"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="datePicked">
                  <svg
                    class="pointer calendar-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <g
                      id="download_3_"
                      data-name="download (3)"
                      transform="translate(-2 -2)"
                    >
                      <path
                        id="Path_3946"
                        data-name="Path 3946"
                        d="M22,4H21V3a1,1,0,1,0-2,0V4H15V3a1,1,0,1,0-2,0V4H9V3A1,1,0,1,0,7,3V4H6A4,4,0,0,0,2,8V22a4,4,0,0,0,4,4H22a4,4,0,0,0,4-4V8A4,4,0,0,0,22,4ZM6,6H7V7A1,1,0,0,0,9,7V6h4V7a1,1,0,0,0,2,0V6h4V7a1,1,0,0,0,2,0V6h1a2,2,0,0,1,2,2v2H4V8A2,2,0,0,1,6,6ZM22,24H6a2,2,0,0,1-2-2V12H24V22A2,2,0,0,1,22,24Z"
                        fill="#fff"
                      />
                      <circle
                        id="Ellipse_284"
                        data-name="Ellipse 284"
                        cx="1"
                        cy="1"
                        r="1"
                        transform="translate(7 15)"
                        fill="#fff"
                      />
                      <circle
                        id="Ellipse_285"
                        data-name="Ellipse 285"
                        cx="1"
                        cy="1"
                        r="1"
                        transform="translate(7 19)"
                        fill="#fff"
                      />
                      <circle
                        id="Ellipse_286"
                        data-name="Ellipse 286"
                        cx="1"
                        cy="1"
                        r="1"
                        transform="translate(11 15)"
                        fill="#fff"
                      />
                      <circle
                        id="Ellipse_287"
                        data-name="Ellipse 287"
                        cx="1"
                        cy="1"
                        r="1"
                        transform="translate(11 19)"
                        fill="#fff"
                      />
                      <circle
                        id="Ellipse_288"
                        data-name="Ellipse 288"
                        cx="1"
                        cy="1"
                        r="1"
                        transform="translate(15 15)"
                        fill="#fff"
                      />
                      <circle
                        id="Ellipse_289"
                        data-name="Ellipse 289"
                        cx="1"
                        cy="1"
                        r="1"
                        transform="translate(15 19)"
                        fill="#fff"
                      />
                      <circle
                        id="Ellipse_290"
                        data-name="Ellipse 290"
                        cx="1"
                        cy="1"
                        r="1"
                        transform="translate(19 15)"
                        fill="#fff"
                      />
                      <circle
                        id="Ellipse_291"
                        data-name="Ellipse 291"
                        cx="1"
                        cy="1"
                        r="1"
                        transform="translate(19 19)"
                        fill="#fff"
                      />
                    </g>
                  </svg>

                  <el-date-picker
                    v-model="orderform.datePicked"
                    type="date"
                    :placeholder="$fn.tr('თარიღი')"
                  >
                  </el-date-picker>
                </el-form-item>

                <el-form-item prop="checked">
                  <el-checkbox v-model="orderform.checked"
                    >{{$fn.tr('ვეთანხმები საიტის')}} <router-link :to="getPolicyLink">{{$fn.tr('წესებს')}}</router-link>
                  </el-checkbox>
                </el-form-item>

                <button class="order-btn" @click.prevent="submitForm('orderform')">
                  <div class="inner-wrapper">
                  

                    <span class="f-21">{{ $fn.tr("გადახდა") }}</span>
                  </div>
              
                </button>
                    <transition name="fade">
                    <div class="success-box" v-if="successMessage">
                      <span class="f-21 bold">{{$fn.tr('თქვენი შეკვეთა წარმატებით განხორციელდა')}}</span>
                    </div>
                  </transition>
                  <transition name="fade">
                    <div class="error-box" v-if="errorMessage">
                      <span class="f-21 bold-italic">{{$fn.tr('დაფიქსირდა შეცდომა, შეკვეთა არ განხორციელდა')}}</span>
                    </div>
                  </transition>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </portal>
</template>

<script>
import errorBlock from "@/components/smartComponents/errorBlock.vue";
import fn from "../../helpers/func";
export default {
  components: {
    errorBlock
  },
  props: ["slide", "total_price", "orderedCocktails"],

  data() {
    var checkName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$fn.tr("გთხოვთ შეიყვანოთ სახელი")));
      } else {
        console.log("correct");
        callback();
      }
    };

    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$fn.tr("გთხოვთ შეიყვანოთ ნომერი")));
      }

      if (!Number.isInteger(value)) {
        callback(new Error(this.$fn.tr("გთხოვთ შეიყვანოთ მხოლოდ ციფრები")));
      } else {
        callback();
      }
    };

    var checkCheckbox = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$fn.tr("გთხოვთ დაეთანხმოთ საიტის წესებს")));
      } else {
        callback();
      }
    };

       var checkLoc = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$fn.tr("გთხოვთ შეიყვანოთ ლოკაცია")));
      } else {
        callback();
      }
    };

      var checkDate = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$fn.tr("გთხოვთ აირჩიოთ თარიღი")));
      } else {
        callback();
      }
    };

    return {
      userError: false,
      user_token: "",
      successMessage: false,
      errorMessage: false,
      // ordered_cocktails: [],
      orderform: {
        phone: "",
        inputname: "",
        datePicked: "",
        inputLocation: "",
        checked: true
      },

      authActive: true,

      orderrules: {
        phone: [
          { required: true, validator: checkPhone, trigger: this.authorize }
        ],
        inputname: [
          { required: true, validator: checkName, trigger: this.authorize }
        ],

        inputLocation: [
          { required: true, validator: checkLoc, trigger: this.authorize }
        ],

        checked: [
          { required: true, validator: checkCheckbox, trigger: this.authorize }
        ],
        datePicked: [
          { required: true, validator: checkDate, trigger: this.authorize }
        ],
      }
    };
  },
  computed: {
    callRegister() {
      return this.$store.state.main.callRegister;
    },

    getPolicyLink(){
        let menus = this.$store.state.main.indx.menus;
        menus = menus.filter(m => m.configs.includes("privacy-policy"));
        return menus[0].full_url;

    }
  },
  mounted() {
   console.log(this.getPolicyLink)
  },
  watch: {
    callRegister(ns, os) {
      this.openorderModal();
      this.openReg();
      console.log(this.regActive);
      this.authActive = false;
      this.regActive = true;
    }
  },
  methods: {
   
    openorderModal() {
      this.$store.state.main.orderActive = !this.$store.state.main.orderActive;
      if (this.$refs.orderform) this.$refs.orderform.resetFields();
      if(this.successMessage)this.successMessage = false;
      if(this.errorMessage)this.errorMessage = false;
    },
      async sendData() {
        let order_data = {}
        order_data.name = this.orderform.inputname;
        order_data.phone = this.orderform.phone;
        order_data.location = this.orderform.inputLocation;
        order_data.date = this.orderform.datePicked;
        order_data.total_price = this.total_price;
        order_data.ordered_cocktails = this.orderedCocktails;

        console.log(order_data)
        let tmp =  await this.$fn.postData('main/SendBarOrder', order_data);
        console.log(tmp)
        if(tmp.status == 200){
          this.successMessage = true;
          
          
        }
       
      },
    openReg() {
      if (this.authActive && !this.regActive) {
        this.authActive = false;
        this.regActive = true;
      } else if (this.regActive && !this.authActive) {
        this.authActive = true;
        this.regActive = false;
      } else if (this.regActiveTwo && !this.regActive && !this.authActive) {
        this.regActiveTwo = false;
        this.authActive = true;
      }

      if (this.$refs.orderform) this.$refs.orderform.resetFields();
    },
    submitForm() {
      this.$refs.orderform.validate(valid => {
        if (valid) {
          console.log("submitted");
          this.sendData();
          
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss">
.el-form-item__error{
    font-family: "FiraGO-BoldItalic";
}
.el-date-table th {
  text-transform: lowercase;
  font-size: 13px;
}
.el-date-picker__header-label {
  text-transform: lowercase;
}
.el-date-table td.today span {
  color: #bacb32;
}
.el-date-table td.current:not(.disabled) span {
  background-color: #03301f;
  width: 35px;
  height: 35px;
  padding-top: 5px;
}
.order-modal-wrapper .el-input__inner {
  width: 100%;
}
.order-modal-wrapper .err input {
  border-bottom: 2px solid #f56c6c;
}
.order-modal-wrapper {
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }

  .el-input__prefix {
    left: initial;
    right: 0;

    .el-icon-date {
      cursor: pointer;
      &:after,
      &:before {
        opacity: 0;
      }
    }
  }
  .calendar-icon {
    position: absolute;
    right: 0;
    top: 6px;
    cursor: pointer;
  }
  position: fixed;
  top: 0;
  right: 0;
  height: 100%;
  width: 660px;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 34px;
  //padding-bottom: 55px;
  z-index: 399;
  background-color: #03301f;
  box-shadow: -5px 0 30px rgba(16, 24, 32, 0.1);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  
  .auth-wrapper,
  .reg-wrapper {
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  .err-block {
    margin-bottom: 20px;
  }

  &::-webkit-scrollbar {
    position: absolute;
    right: 0;
    top: 0;
    width: 5px;
    cursor: pointer;
  }
  &::-webkit-scrollbar-track {
    background-color: white;
    cursor: pointer;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #bacb32;
    border-radius: 10px;
    cursor: pointer;
  }
  .order-modal-inner {
    position: relative;
    padding-left: 25px;
    padding-right: 25px;
       @media (max-width: 1365px){
    padding-bottom: 20px;
  }
    @media (max-width: 1023px){
    padding-bottom: 60px;
  }
  }
  .social-order-btns {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 55px;
  }
  .google-btn,
  .fb-btn {
    width: 260px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid white;
    transition: 0.4s;
    cursor: pointer;
    span {
      margin-left: 10px;
      color: white;
      transition: 0.4s;
    }
    svg path {
      transition: 0.4s;
    }
    @media (min-width: 1024px) {
      &:hover {
        background-color: white;
        span {
          color: #03301f;
        }
        svg path {
          fill: #03301f;
        }
      }
    }
  }

  h2 {
    color: #bacb32;
    margin-bottom: 55px;
  }
  .close-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 55px;
    span {
      color: white;
    }
  }
  .close-btn {
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: 0.4s;
    will-change: transform;
    svg path {
      fill: white;
    }
    @media (min-width: 1024px) {
      &:hover {
        transform: scale(1.1) rotate(-2deg);
      }
    }
    svg {
      margin-right: 9.6px;
    }
  }
  .el-input__inner {
    font-size: 21px;
    background: transparent;
    font-family: "FiraGO-BoldItalic";

    padding-bottom: 13px;
    //  border-color: rgba(255, 255, 255, 0.3);
    border-bottom: 2px solid rgba(255, 255, 255, 0.3);
    border-top: none;
    border-left: none;
    border-right: none;
    padding-left: 0;
    border-radius: 0;
    outline-width: 0 !important;
    height: 40px;
    color: white;
    outline: 0 !important;
    &:focus {
      outline: 0 !important;
      outline-width: 0 !important;
    }
    -moz-appearance: textfield;
    &::placeholder {
      color: rgba(255, 255, 255, 0.5);
    }
    &:-ms-input-placeholder {
      color: rgba(255, 255, 255, 0.5);
    }
    &::-moz-placeholder {
      color: rgba(255, 255, 255, 0.5);
    }
    &::-webkit-input-placeholder {
      color: rgba(255, 255, 255, 0.5);
    }
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    -moz-appearance: textfield;
  }
  .order-modal-footer {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    padding-top: 89px;
    padding-bottom: 55px;
    span {
      &:nth-child(1) {
        color: rgba(255, 255, 255, 0.7);
      }
      &:nth-child(2) {
        color: #bacb32;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
  .orderinmail {
    margin-bottom: 21px;
  }
  .orderinname {
    margin-top: 24px;
    margin-bottom: 21px;
  }

  .order-btn {
    background: url("../../assets/img/authbtnbg.png");
    display: flex;
    justify-content: center;
    align-items: center;
    background-size: 100% 100%;
    width: 196px;
    height: 58px;
    cursor: pointer;
    margin-top: 34px;
    transition: 0.4s;
    will-change: transform;
    span {
      color: #03301f;
    }
    @media (min-width: 1024px) {
      &:hover {
        transform: scale(1.1) rotate(-2deg);
      }
    }
  }
  .forgot-name {
    span {
      color: white;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .reg-wrapper {
    position: relative;
    .or {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      margin-bottom: 19.5px;
      span {
        color: white;
      }
    }
  }
  .tool-tip-row {
    display: flex;
    align-items: center;
    span {
      color: white;
      margin-left: 6px;
    }
  }
  .el-checkbox {
    display: flex;
    align-items: center;
    margin-top: 35px;
    color: white;
    font-family: "FiraGO-Italic";
    font-size: 13px;
    &__input.is-checked + .el-checkbox__label {
      color: white;
      font-family: "FiraGO-Italic";
    }
    &__label {
      color: white;
      font-family: "FiraGO-Italic";
    }
    a {
      color: #fdcf18;
      font-family: "FiraGO-Italic";
      font-size: 13px;
      text-decoration: underline;
    }
    &__inner {
      background-color: transparent;
      border: none;
      background: url("../../assets/img/checkbox.png");
      background-size: cover;
      width: 24px;
      height: 24px;
      &::after {
        display: none;
      }
    }
  }

  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: transparent;
    border-color: transparent;
    background: url("../../assets/img/checkboxchecked.png");
    background-size: cover;
    width: 24px;
    height: 24px;
  }

  .sms-sent {
    border: white 1px solid;
    background-color: rgba(255, 255, 255, 0.2);
    width: 550px;
    height: 95px;
    padding: 21px 34px 21px 34px;
    display: flex;
    margin-bottom: 13px;
    svg {
      margin-right: 10px;
    }
    span {
      color: white;
    }
  }
  .resend {
    text-decoration: underline;
    color: white;
    cursor: pointer;
  }
  @media (max-width: 767px) {
    width: 100%;
    .order-modal-inner {
      padding-left: 0;
      padding-right: 0;
    }
  }
}
.success-box{
  margin-top: 30px;
  span{
  color:#bacb32;

  }
}
.error-box{
  margin-top: 30px;
  span{
  color:#f56c6c;

  }
}
.from-right-enter-active {
  transition: all 0.9s cubic-bezier(0.33, 1, 0.68, 1);
}
.from-right-leave-active {
  transition: all 0.9s cubic-bezier(0.32, 0, 0.67, 0);
}
.from-right-enter {
  transform: translateX(100%);
}
.from-right-leave-to {
  transform: translateX(100%);
}
</style>
